<div class="container-fluid admin-form-page">
  <div class="row section1">
    <div class="col-12 col-md-7 col-lg-7 col-xl-7">
      <div class="home-details">
        <h5 class="home-title">Edit user details</h5>
        <p class="home-subtitle">Fill all the below fields (Fields with *are mendatory)</p>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-5 col-xl-5">
      <div class="dashboard-btn dashboard-manage admin-page-actions mr-3">
        <div>
          <button (click)="goBack()" type="button" class="btn btn-primary btn-dashboard ">Back</button>
        </div>
      </div>
    </div>
  </div>
  <div class="section1">
    @if (user) {
      <div class="applicants-details details1 admin-form-card">
        <form class="admin-form" ngNativeValidate (ngSubmit)="updateUser()">
          <div class="row align-items-center">
            <div class="col-auto ">
              <div class="user-form">
                <div class="form-group d-flex flex-column">
                  <label>Profile Picture*</label>
                  @if (user.profile) {
                    <img class="position-relative rounded-circle" style="object-fit: cover" width="100"
                      height="100"
                      src="{{user.profile}}" alt="">
                  }
                  @if (!user.profile) {
                    <img class="position-relative rounded-circle" style="object-fit: cover"
                      width="100"
                      height="100"
                      src="assets/images/placeholder.png" alt="">
                    }
                    @if (!user.profile && !uploading) {
                      <i (click)="handleClickUpload()"
                      class="las font-size-16 la-plus-circle img-icon"></i>
                    }
                    @if (user.profile && !uploading) {
                      <i (click)="handleClickUpload()"
                      class="las font-size-16 la-pencil-alt img-icon"></i>
                    }
                    @if (uploading) {
                      <div class="img-icon-loader">
                        <img src="assets/images/loading.gif" width="40" alt="">
                      </div>
                    }
                  </div>
                  <input id="dp" name="file-upload-field" type="file"
                    accept=".png, .jpg, .jpeg, .webp"
                    class="form-control d-none"
                    (change)="uploadImage($event)">
                </div>
              </div>
              <div class="col-4">
                <div class="user-form">
                  <div class="form-group">
                    <label for="first-name">First Name*</label>
                    <input type="text" class="form-control" id="first-name" name="first-name" [(ngModel)]="user.firstName"
                      placeholder="Enter First Name" required autocomplete="off">
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="user-form">
                  <div class="form-group">
                    <label for="last-name">Last Name*</label>
                    <input type="text" class="form-control" id="last-name" name="last-name" [(ngModel)]="user.lastName"
                      placeholder="Enter Last Name" required autocomplete="off">
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="user-form">
                  <div class="form-group">
                    <label for="user-type">User Type</label>
                    <select id="user-type" class="form-control" [(ngModel)]="user.type" name="type">
                      <option value="Bhakt">Bhakt</option>
                      <option value="Vishwaguru">Vishwagurus</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="user-form">
                  <div class="form-group">
                    <label for="email">Email*</label>
                    <input type="email" class="form-control" name="email" [(ngModel)]="user.email" id="email"
                      placeholder="Enter Email">
                  </div>
                </div>
              </div>
              <div class="col-3 ">
                <div class="user-form">
                  <div class="form-group">
                    <label for="fb-link">Facebook Link</label>
                    <input type="text" class="form-control" id="fb-link" name="facebook"
                      [(ngModel)]="user.facebookLink" placeholder="Enter Facebook Link">
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="user-form">
                  <div class="form-group">
                    <label for="twitter-link">Twitter Link</label>
                    <input type="text" class="form-control" id="twitter-link" name="twitter"
                      [(ngModel)]="user.twitterLink" placeholder="Enter Twitter Link">
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="user-form">
                  <div class="form-group">
                    <label for="insta-link">Instagram Link</label>
                    <input type="text" class="form-control" id="insta-link" name="instagram"
                      [(ngModel)]="user.instagramLink" placeholder="Enter Instagram Link">
                  </div>
                </div>
              </div>
              <div class="col-7 ">
                <div class="user-form">
                  <div class="form-group">
                    <label for="bio">Your Bio</label>
                    <textarea class="form-control" [(ngModel)]="user.bio" name="bio" placeholder="Enter your bio"
                    id="bio"></textarea>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="user-form">
                  <div class="form-group">
                    <label for="twitter-user-name">Twitter user name</label>
                    <input type="text" class="form-control" id="twitter-user-name" name="twitterHandle" [(ngModel)]="user.twitterHandle"
                      placeholder="Enter twitter user name" autocomplete="off">
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="user-form textarea">
                  <div class="form-group">
                    <label>Super user</label>
                    <select class="form-control" [(ngModel)]="user.canManageUnclaimedUserActivity" name="userType"
                      id="superUser">
                      <option [value]=true>Yes</option>
                      <option [value]=false>No</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            @if (!!scoreModels.length) {
              <h5 class="font-weight-bold">Score model</h5>
              <div class="row">
                @for (scoreModel of scoreModels; track scoreModel) {
                  <div class="col-4">
                    <div class="user-form">
                      <div class="form-group">
                        <label [for]="scoreModel.fieldSlug">{{scoreModel.fieldLabel}}</label>
                        <input type="text" class="form-control" [id]="scoreModel.fieldSlug" [name]="scoreModel.fieldSlug"
                          [(ngModel)]="scoreModel.fieldValue"
                          maxlength="5"
                          oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1')"
                          [placeholder]="'Enter ' + scoreModel.fieldLabel" autocomplete="off">
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
            <div class="row justify-content-end mt-3 mr-1">
              <button class="btn btn-primary btn-dashboard" type="submit">Save user details
                @if (loading) {
                  <span><img src="assets/images/loading.gif" width="20" alt=""></span>
                }
              </button>
            </div>
          </form>
        </div>
      }
    </div>
  </div>
